import { useAuth } from "../context/AuthContext";
import { Button } from "../components/common/Button";
import styles from "./LoginScreen.module.css";

export function LoginScreen() {
  const { login } = useAuth();
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <img className={styles.logo} src="/logo-banner.png" alt="" />
        <h1 className={styles.visuallyHidden}>A Beekeepers Chronicle</h1>
        <p>Sign in to manage your hives, business, and team.</p>
        <Button onClick={login}>Sign In</Button>

        {/*
          * A ROUTE TO SIGNING UP, FROM THE SIGN-IN SCREEN (#502).
          *
          * Reported 6 Oct: "it's confusing you have to click 'SignIn' and
          * then click the 'No Account' button."
          *
          * Exactly so, and it is the worst place in the product to lose
          * somebody: account creation sat two steps behind a button
          * labelled for the opposite intent, on the first screen a new
          * user sees.
          *
          * IT CANNOT DEEP-LINK, and the copy is written so that does not
          * matter. The tenant runs ONE combined user flow
          * (B2C_1_signupsignin), so the "Create one" control lives on
          * Microsoft's hosted page rather than here, and there is no
          * documented parameter that opens that page on its sign-up half.
          * Passing an undocumented one would be worse than this: a
          * promise that silently stops working is how #306's guidance
          * problem started.
          *
          * So this says where the control is rather than pretending to be
          * it. That still fixes the reported confusion -- somebody with
          * no account now knows this screen is for them -- without
          * claiming a behaviour we have not verified against the tenant.
          *
          * The tenant-side fix is #306's custom page templates, which is
          * where "make that page say Create Account properly" belongs.
          */}
        <p className={styles.createAccount}>
          No account yet?{" "}
          <button type="button" onClick={login} className={styles.createLink}>
            Create one
          </button>{" "}
          — continue to sign-in and choose <em>Create one</em> on the next page.
        </p>
        {/*
          * THE PASSWORD RULE, BEFORE THE PAGE THAT ENFORCES IT (#306).
          *
          * Reported from a real sign-up during #222 testing. The
          * "Create your password" page is served by the External ID
          * tenant, not by us -- it refuses a weak password and does not
          * say what it considers weak. The user hits an error, guesses,
          * and hits it again, at the single worst moment in the funnel:
          * before they own anything and with nothing invested.
          *
          * We cannot fix that page from here. We CAN say it before the
          * handoff, on the screen we fully control and which cannot
          * silently stop working the way tenant branding can.
          *
          * WEAKER THAN FIXING THE PAGE, and deliberately kept as a
          * supplement rather than called the fix: somebody who clicks
          * "Create one" from the sign-in page directly never sees this.
          * The other two routes in #306 -- company branding text and
          * custom page templates -- still want doing.
          *
          * VERIFIED AGAINST THE TENANT, 18 Sep, by attempting a sign-up:
          * an 8-character password using two character types is refused and
          * three is accepted. #306 is explicit that guidance which does not
          * match what the page enforces is worse than none -- it turns one
          * confusing refusal into a broken promise -- so this was checked
          * against the real flow rather than against Microsoft's docs alone.
          */}
        <p className={styles.passwordHint}>
          Creating an account? Your password needs 8 characters or more, using at
          least three of: a capital, a lowercase letter, a number, a symbol.
        </p>
      </div>
    </div>
  );
}
